// extracted by mini-css-extract-plugin
export default {"tabsHeader":"cb_jy","titleAndTab":"cb_jz"};